export const agreementTemplateTranslations = {
  lv: {
    title: 'Līgumu sagataves',
    count_zero: '{{count}} sagatavju',
    count_one: '{{count}} sagatave',
    count_other: '{{count}} sagataves',
    description:
      'Līguma sagatave ir .docx datne ar vietturiem ({Nr}, {OrgName}, …), no kuras veido trīspusējos prakses līgumus. Jauna sagatave ir neaktīva — to var aktivizēt tikai pēc datnes augšupielādes. Datnē jābūt visiem obligātajiem vietturiem.',
    search: 'Meklēt pēc nosaukuma vai prefiksa…',
    empty: 'Sagataves nav atrastas',
    fields: {
      title: 'Nosaukums',
      description: 'Apraksts',
      language: 'Valoda',
      nrPrefix: 'Numura prefikss',
      file: 'Līguma sagatave (.docx)',
    },
    columns: {
      title: 'Nosaukums',
      description: 'Apraksts',
      nrPrefix: 'Prefikss',
      language: 'Valoda',
      active: 'Statuss',
      hasFile: 'Datne',
      internshipCount: 'Prakses',
      activeInternshipCount: 'Aktīvās prakses',
      internCount: 'Praktikanti',
      activeInternCount: 'Aktīvie praktikanti',
    },
    statuses: {
      active: 'Aktīva',
      inactive: 'Neaktīva',
    },
    file: {
      yes: 'Ir',
      no: 'Nav',
    },
    filters: {
      button: 'Filtri',
      title: 'Filtrēt sagataves',
      clear: 'Notīrīt',
      apply: 'Filtrēt',
      active: 'Aktīvie filtri',
      remove: 'Noņemt filtru “{{filter}}”',
      language: 'Valoda',
      status: 'Statuss',
      use: 'Izmantošana',
      all: 'Visas',
      statuses: {
        all: 'Visas',
        active: 'Aktīvas',
        inactive: 'Neaktīvas',
      },
      uses: {
        all: 'Visas',
        used: 'Izmantotas',
        unused: 'Neizmantotas',
      },
    },
    actions: {
      create: 'Izveidot sagatavi',
      edit: 'Rediģēt',
      upload: 'Augšupielādēt datni',
      download: 'Lejupielādēt datni',
      downloadSample: 'Lejupielādēt sagataves paraugu',
      usedPlaceholder: 'Izmantotie vietturi',
      enable: 'Aktivizēt',
      disable: 'Deaktivizēt',
      toggle: 'Mainīt sagataves statusu',
      menu: 'Sagataves darbības',
      save: 'Saglabāt',
      uploadSubmit: 'Augšupielādēt',
    },
    placeholders: {
      required: 'Obligātie vietturi',
      optional: 'Neobligātie vietturi',
      missing: 'trūkst',
      count: '× {{count}}',
    },
    confirmEnable: 'Aktivizēt sagatavi “{{title}}”?',
    confirmDisable: 'Deaktivizēt sagatavi “{{title}}”?',
    validation: {
      title: 'Nosaukums ir obligāts',
      nrPrefix: 'Numura prefikss ir obligāts',
      language: 'Izvēlieties valodu',
      file: 'Izvēlieties .docx datni',
    },
    messages: {
      created: 'Sagatave izveidota',
      updated: 'Sagatave saglabāta',
      enabled: 'Sagatave aktivizēta',
      disabled: 'Sagatave deaktivizēta',
      uploaded: 'Datne augšupielādēta',
      downloadError: 'Neizdevās lejupielādēt datni',
      failed: 'Darbība neizdevās',
    },
  },
  en: {
    title: 'Agreement templates',
    count_one: '{{count}} template',
    count_other: '{{count}} templates',
    description:
      'An agreement template is a .docx file with placeholders ({Nr}, {OrgName}, …) that three-party internship agreements are made from. A new template is inactive — it can be activated only after a file is uploaded. The file must contain every required placeholder.',
    search: 'Search by title or prefix…',
    empty: 'No templates found',
    fields: {
      title: 'Title',
      description: 'Description',
      language: 'Language',
      nrPrefix: 'Number prefix',
      file: 'Agreement template (.docx)',
    },
    columns: {
      title: 'Title',
      description: 'Description',
      nrPrefix: 'Prefix',
      language: 'Language',
      active: 'Status',
      hasFile: 'File',
      internshipCount: 'Internships',
      activeInternshipCount: 'Active internships',
      internCount: 'Interns',
      activeInternCount: 'Active interns',
    },
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
    },
    file: {
      yes: 'Yes',
      no: 'No',
    },
    filters: {
      button: 'Filters',
      title: 'Filter templates',
      clear: 'Clear',
      apply: 'Apply filters',
      active: 'Active filters',
      remove: 'Remove “{{filter}}” filter',
      language: 'Language',
      status: 'Status',
      use: 'Use',
      all: 'All',
      statuses: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
      },
      uses: {
        all: 'All',
        used: 'Used',
        unused: 'Unused',
      },
    },
    actions: {
      create: 'Create template',
      edit: 'Edit',
      upload: 'Upload file',
      download: 'Download file',
      downloadSample: 'Download sample template',
      usedPlaceholder: 'Used placeholders',
      enable: 'Activate',
      disable: 'Deactivate',
      toggle: 'Change template status',
      menu: 'Template actions',
      save: 'Save',
      uploadSubmit: 'Upload',
    },
    placeholders: {
      required: 'Required placeholders',
      optional: 'Optional placeholders',
      missing: 'missing',
      count: '× {{count}}',
    },
    confirmEnable: 'Activate the template “{{title}}”?',
    confirmDisable: 'Deactivate the template “{{title}}”?',
    validation: {
      title: 'Title is required',
      nrPrefix: 'Number prefix is required',
      language: 'Choose a language',
      file: 'Choose a .docx file',
    },
    messages: {
      created: 'Template created',
      updated: 'Template saved',
      enabled: 'Template activated',
      disabled: 'Template deactivated',
      uploaded: 'File uploaded',
      downloadError: 'Could not download the file',
      failed: 'The action failed',
    },
  },
}
